import { ChevronDown, ChevronsUpDown, ChevronUp } from "lucide-react";
import { Column } from "@tanstack/react-table";
import { cn } from "../../lib/utils";
import { Button } from "../button";

export function SortableHeader<TData, TValue>({
  children,
  column,
  className,
  ascFirst = false,
}: {
  children: React.ReactNode;
  column: Column<TData, TValue>;
  className?: string;
  ascFirst?: boolean;
}) {
  /**
   * Most sortable columns have numerical values that is expected to be sorted in desc order on first click.
   * There could be some fields like rank where the expectation is inverse.
   * When ascFirst is true, first click should sort the column in ascending order
   * false -> asc
   * When it is clicked again, it should go from asc -> desc and finally should clear the sort
   */
  const handleSort = () => {
    const currentSort = column.getIsSorted();
    if (currentSort === false) {
      column.toggleSorting(!ascFirst, false);
    } else if (currentSort === (ascFirst ? "asc" : "desc")) {
      column.toggleSorting(ascFirst, false);
    } else {
      column.clearSorting();
    }
  };

  return (
    <div
      className={cn(
        "font-semibold flex-shrink-0 text-sm flex items-center gap-2",
        className
      )}
    >
      {children}
      <Button
        variant="ghost"
        size="icon"
        className="size-6"
        onClick={handleSort}
      >
        {column.getIsSorted() === "asc" && <ChevronDown className="h-4 w-4" />}
        {column.getIsSorted() === "desc" && <ChevronUp className="h-4 w-4" />}
        {column.getIsSorted() === false && (
          <ChevronsUpDown className="h-4 w-4" />
        )}
      </Button>
    </div>
  );
}
